<template>
  <div id="richlink">
    <router-link :class="classes" v-if="route" :to="`${route}`" @click="onClick">
      <MyIcon
        v-if="icon || unicode"
        :style="{ 'margin-inline-end': iconsize / 2 + 'px' }"
        :name="icon"
        :is-svg="isSvg"
        :size="iconsize"
        :url="iconurl"
        :unicode="unicode"
      />
      <component :is="as">{{ label }}</component>
    </router-link>
    <a
      :class="classes"
      class="external"
      v-else-if="link"
      target="_blank"
      :href="`${link}`"
      @click="onClick"
    >
      <MyIcon
        v-if="icon || unicode"
        :style="{ 'margin-inline-end': iconsize / 2 + 'px' }"
        :name="`${icon}`"
        :is-svg="isSvg"
        :size="iconsize"
        :url="iconurl"
        :unicode="unicode"
      />
      <component :is="as" class="label-text">{{ label }}</component>
    </a>
    <a :class="classes" v-else target="_blank" @click="onClick">
      <MyIcon
        v-if="icon || unicode"
        :style="{ 'margin-inline-end': iconsize / 2 + 'px' }"
        :name="`${icon}`"
        :is-svg="isSvg"
        :size="iconsize"
        :url="iconurl"
        :unicode="unicode"
      />
      <component :is="as">{{ label }}</component>
      <MyIcon
        v-if="iconRight || unicodeRight"
        :style="{ 'margin-inline-start': iconsize / 2 + 'px' }"
        :name="`${iconRight}`"
        :is-svg="isSvg"
        :size="iconsize"
        :url="iconurl"
        :unicode="unicodeRight"
      />
    </a>
  </div>
</template>

<script>
import MyIcon from './../Icon.vue';
import { reactive, computed } from 'vue';

export default {
  name: 'TextLink',
  components: {
    MyIcon,
  },
  props: {
    label: {
      type: String,
      required: true,
      default: 'Text Link Label',
    },
    route: {
      type: String,
    },
    isSvg: {
      type: Boolean,
      default: true,
    },
    link: {
      type: String,
    },
    icon: {
      type: String,
    },
    iconRight: {
      type: String,
    },
    iconsize: {
      type: String,
      default: '64',
    },
    iconurl: {
      type: String,
    },
    unicode: {
      type: String,
    },
    unicodeRight: {
      type: String,
    },
    as: {
      type: String,
      default: 'p',
    },
    // Override props
    large: {
      type: Boolean,
      default: false,
      required: false,
    },
    left: {
      type: Boolean,
      default: false,
      required: false,
    },
    right: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  emits: ['click'],
  setup(props, { emit }) {
    const reactiveProps = reactive(props);
    return {
      classes: computed(() => ({
        'link-size': true,
        'link-size--large': reactiveProps.large,

        'link-left': true,
        'link-left--left': reactiveProps.left,
        'link-left--default': !reactiveProps.left,

        'link-right': true,
        'link-right--right': reactiveProps.right,
        'link-right--default': !reactiveProps.right,
      })),
      onClick() {
        emit('click');
      },
    };
  },
};
</script>
<style></style>

<style lang="scss" scoped>
// Links should inherit global link styles, not parent element colors
// * {
//   color: inherit;
// }

.link-size {
  /* background: var(--color-xlight); */
  display: flex;
  align-items: center;
}

/* .link-size--default */

.link-size--large {
  font-size: var(--font-lg) !important;
  --reading-fontWeight: var(--font-lg-weight);
  font-weight: var(--font-lg-weight) !important;
}

/* .link-left */

.link-left--left:before {
  content: '★ ';
  color: var(--link);
  text-decoration: none;
}

/* .link-right */

.link-right--right:after {
  content: ' ★';
  color: var(--link);
}

/* ---- External Link ---- */
.external {
  text-decoration: none !important;
  .label-text {
    text-decoration: underline;
    text-decoration-color: var(--foreground);
    text-decoration-thickness: 0.15rem;
    text-underline-offset: 0.75rem;
  }

  &::after {
    content: ' ↗';
    text-decoration: none;
    display: inline-block;
    margin-inline-start: 0.2em;
  }

  &:hover .label-text {
    text-decoration: underline wavy var(--foreground);
    text-decoration-thickness: 0.2rem;
    text-underline-offset: 0.75rem;
  }
}
</style>
